import React from 'react';
import { FormattedNumber, FormattedMessage, FormattedHTMLMessage, FormattedDate } from 'react-intl';
import data from '../constants/currencyData.json';

function getCurrencyCode(currencyCode, lang) {
    lang = lang || 'en';
    if (typeof currencyCode !== 'string') {return undefined;}
    const code = currencyCode.toUpperCase();
    if (!data.hasOwnProperty(code)) {return undefined;}
    const codeSymbol =
        lang && data[code].locale && data[code].locale === lang ? data[code].symbol_native : data[code].symbol;
    return codeSymbol;
}

const url = document.URL.replace(/^(?:\/\/|[^\/]+)*\//, '/');
const urlLang = url.split('/')[1]; // en-ae
const lang = urlLang === 'ar' ? 'ar' : 'en'; // Restrict to only 'ar' or 'en'

const I18n = {
    formatCurrency: function(currency, options = {}) {
        let amount = '';
        if (typeof currency === 'object' && currency.currency) {
            amount = currency.value;
            amount = amount !== 0 ? !amount || amount === null ? '' : amount : amount;
            options.unit = currency.currency;
        } else {
            amount = currency;
            options.unit = 'AED';
        }

        // XXX: Double check this as it seems like an unintended multiline if.
        let value = '';
        if (String(amount) && typeof amount !== 'object') {
            value = Number(amount);
        }

        const valueClass = options.valueClass || 'value';
        const currencyClass = options.currencyClass || '';
        let minimumFractionDigits = options.minimumFractionDigits || 2;

        // Since 0 is taken as false
        if (options.minimumFractionDigits === 0) {
            minimumFractionDigits = 0;
        }

        return (
            <span>
                {lang === 'en' &&
                    <span className={currencyClass}>
                        {getCurrencyCode(options.unit, lang)}{value !== '' ? ' ' : ''}
                    </span>}
                <span className={valueClass}>
                    {value.toLocaleString('en', { minimumFractionDigits, maximumFractionDigits: 2 })}
                </span>
                {lang === 'ar' &&
                    <span className={currencyClass}>
                        {value !== '' ? ' ' : ''}{getCurrencyCode(options.unit, lang)}
                    </span>}
            </span>
        );
    },
    // eslint-disable-next-line react/display-name
    getText: function(id, values, defaultMessage, tagName) {
        if (!values) {
            values = {};
        }
        return (
            <FormattedMessage
                key={Math.floor(Math.random() * 1000000) + 1}
                id={id}
                values={values}
                defaultMessage={defaultMessage}
                tagName={tagName}
            />
        );
    },
    // eslint-disable-next-line react/display-name
    getHtml: function(id, values, defaultMessage, tagName) {
        if (!values) {
            values = {};
        }
        return (
            <FormattedHTMLMessage
                key={Math.floor(Math.random() * 1000000) + 1}
                id={id}
                values={values}
                defaultMessage={defaultMessage}
                tagName={tagName}
            />
        );
    },
    // eslint-disable-next-line react/display-name
    getComponent: function(component, id, values, defaultMessage) {
        if (!values) {
            values = {};
        }
        return (
            <FormattedMessage id={id} values={values} defaultMessage={defaultMessage}>
                {component}
            </FormattedMessage>
        );
    },
    // eslint-disable-next-line react/display-name
    getDate: function(timestamp) {
        if (!timestamp) {
            return null;
        }

        return <FormattedDate value={timestamp} year="numeric" month="short" day="numeric" />;
    },
    // eslint-disable-next-line react/display-name
    getformattedNumber: function(number) {
        return <FormattedNumber value={number} />;
    },
    // eslint-disable-next-line react/display-name
    getRawCurrency: function() {
        const unit = 'AED';
        return getCurrencyCode(unit, lang);
    },
};

export default I18n;



// WEBPACK FOOTER //
// ./src/i18n/I18n.js